import React, {useState, useRef, useEffect, Fragment} from 'react';
import SliderRegistriTemplates from '../SliderRegistriTemplates'
import { useStateContext } from '../../context/StateContext';
import Divider from '../frontend_components/Divider';
import TrueFalseToggle from '../TrueFalseToggle';
import VisDiv from '../frontend_components/VisDiv';
import TextHighlight from '../frontend_components/TextHighlight';
import {FiEdit} from 'react-icons/fi'
import {AiFillCloseCircle} from 'react-icons/ai';
import NonConformityPin from '../NonConformityPin';
import SaveButton from '../frontend_components/SaveButton';
import { errorAlert, keyId, sortByLabel, successAlert, addValueForDropdown, capitalizeFirst } from '../../lib/utils';
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import Loading from '../Loading';
import { useQueryClient } from '@tanstack/react-query';
import FieldDropdown from '../FieldDropdown';
import InsertNewCustomerProduct from '../InsertNewCustomerProduct';
import NonConformitiesManagement from '../management/NonConformitiesManagement';
import { usePreventScroll } from 'react-aria';
import RegisterIcon from '../RegisterIcon';
import { referenceDoc, richEditorDoc } from '../gestioneDatabase/Docs';
import { v4 as uuidv4 } from 'uuid'; 
import { IoMdCloseCircle } from "react-icons/io";
import { useManagementContext } from '../../context/ManagementContext';

/**
 * Analisi non conformita' e prodotti di un cliente
 * Serve per visualizzarele non conformita' e i loro prodotti, in quanto di norma il setup è prodotto centrico, prodotto con le sue non conformita'.
 * @param {Object} data - Oggetto contenente i dati relativi ai prodotti del cliente
 * @returns {JSX} - Componente React che rappresenta l'analisi delle non conformita' e prodotti di un cliente
 */
const AnalisiNonConformitaEProdotti = ({data}) => {
    const {
        customer,
        setLoading,
        loading,
        LDB,

    } = useStateContext();
    const {newCustomerProduct, setDefaultOfferMenu, setNewNonConformity, newNonConformity, setNewCustomerProduct} = useManagementContext()



    const queryClient = useQueryClient()
    const {customerProducts, nonConformities, templateRegisters, presidioModules, deviceProperties, priceLists, lists, dataModules, templateRegister, laws, products, suppliers} = data

    const[registerTemplateFilter, setRegisterTemplateFilter] = useState()
    const[empty, setEmpty] = useState(false)
    const[supply, setSupply] = useState(false)
    const[sub, setSub] = useState(false)
    const[assigned, setAssigned] = useState(false)
    
    const [editDocument, setEditDocument] = useState(undefined)
    const [customerProductList, setCustomerProductList] = useState([])
    const[toggleEdit, setToggleEdit] = useState(false)
    const editSizeLeft = toggleEdit ? {width: "20%" } : {}
    const editSizeRight = toggleEdit ? {width: "80%" } : {}

    const registerCustomerProducts = !Array.isArray(customerProducts) ? [] : customerProducts
   // ?.filter?.(x=>!x?.supply)

    usePreventScroll({isDisabled: toggleEdit ? false : true})


    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {
    
            await queryClient.cancelQueries({ queryKey: ["customerProductsReport"] })
            const previousData = queryClient.getQueryData(["customerProductsReport"])
            const doc = newDoc?.doc
            queryClient.setQueryData(["customerProductsReport"], (old) =>{ 
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!==doc?._id), {...doc}]
                return newData
            })
            return { previousSites: previousData}
        },
        onError:()=>{
            errorAlert("Errore: il documento non é stato aggiornato")
        }
    
    })

    const updateDocManually = () => {
        const doc = !Array.isArray(registerCustomerProducts) ? {} : registerCustomerProducts?.find?.((x)=>x?._id == "6197a2f8-b2ae-487c-a087-67e1d4781e34")
        const updatedDoc = {...doc,  supplierProducts: !Array.isArray(doc?.supplierProducts) ? [] : doc?.supplierProducts?.filter?.((x)=>x)}
        console.log(doc, updatedDoc)
        updateDocument({doc: updatedDoc})
    }
    const viewBadProducts = () => {
        const idLaw = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.law?._id)
        const idProducts = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.supplierProducts?.some?.(y=>y?._id))
        return ({idLaw, idProducts})
    }

    const updateCustomerProducts = () => {
        const nonConformity = editDocument?.nonConformity
        const referenceDoc = {_ref: nonConformity?._id, _type:"reference", _key: keyId()}
        console.log("customerProductList", customerProductList, referenceDoc, editDocument)

        const createNonConformities = async (req, res) => {
        
            const queue = new PromiseQueue({
              concurrency: 12,
              intervalCap: 15,
              interval: 700,
            })
            setLoading(true)
            for(const item of registerCustomerProducts){

                const isItemInList = customerProductList?.some?.((x)=>x?._id == item?._id)
                const isInProductList = item?.nonConformities?.some?.((x)=>x?._ref == nonConformity?._id)

                if(isItemInList && isInProductList){
                    console.log(`SI NON CONFORMITA' SI LISTA PRODOTTO:  ${item?.label}`)
                }
                if(!isItemInList && !isInProductList){
                    console.log("NO NON CONFORMITA' NO LISTA PRODOTTO")
                }
                if(!isItemInList && isInProductList){
                 
                    const doc = {...item, nonConformities: !Array.isArray(item?.nonConformities) ? [] : item?.nonConformities?.filter?.((x)=>x?._ref !== nonConformity?._id)}
                    console.log(`NO NON CONFORMITA' SI' LISTA PRODOTTO: ${item?.label}`, doc)
                    queue.add(() => {
                        return updateDocument({doc})
                     })
                 
                }
                if(isItemInList && !isInProductList){
                
                    const doc = {...item, nonConformities: [...item?.nonConformities, referenceDoc ]}
                    console.log(`SI LISTA NO NON CONFORMITA' PRODOTTO: ${item?.label}`, doc)
                    queue.add(() => {
                        return updateDocument({doc})
                    })
                  
                }
            }
            setLoading(false)
  
        }
        const idLaw = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.law?._id)
        const idProducts = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.supplierProducts?.some?.(y=>y?._id))
        const checks = () => {
            //if(idLaw?.length > 0 ) return false
            //if(idProducts?.length > 0) return false
            return true
        }
        if(!checks()){
            errorAlert("Il prodotto non è stato salvato, ricaricare e riprovare")
            console.log("wjhdbwejhdb ERRORE SALVATAGGIO", idLaw, idProducts)
        }
        else {
            createNonConformities()?.then(()=>{
                setEditDocument(undefined) 
                setCustomerProductList([]) 
                setToggleEdit(!toggleEdit)
            })
          
        }
       
    }

    // search-box
    const [searchValue, setSearchValue] = useState("");
    const searchRef = useRef();
    const [searchNcValue, setSearchNcValue] = useState("");
    const searchNcRef = useRef();
    //=======================

    const testFunction = () => {
        console.log("ANALISI:", data)
        console.log("BAD PRODUCTS:", viewBadProducts())
     
        //updateDocManually()
    }
    const supplyFilter = (x) => {
        //if(supply) return x?.supply
        return !x?.supply
    }
    const nonConformititesFilter = (x) =>{
         // search-box
        const search =  x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
       // if(editDocument) return x?._id == editDocument?.nonConformity?._id
        if(empty && registerTemplateFilter) return !x.informative && search && x?.registers?.some?.((y)=>y?._ref == registerTemplateFilter?._id && filteredCustomerProducts(x)?.length < 1 ) 
        if(empty && !registerTemplateFilter) return !x.informative && search && filteredCustomerProducts(x)?.length < 1
        if(registerTemplateFilter) return search && x?.registers?.some?.((y)=>y?._ref == registerTemplateFilter?._id) 
       
        //if(searchValue) return x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
        // ==========
        return search && x
    }
    const editNonConfAssigned = (y) => {
        if(assigned) return customerProductList?.some?.((x)=>x?._id == y?._id)
        return y
    }
    const editNonConfSearchFilter = (x) => {
        const search =  x?.label?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        const isRegister = x?.registers?.some?.((y)=> editDocument?.nonConformity?.registers?.some?.((z)=>z?._ref == y?._ref))
        //console.log("XXXX", editDocument?.nonConformity)
        return search && isRegister
    }
    const filteredCustomerProducts = (nonConformity) => !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.((x)=>!Array.isArray(x?.nonConformities) ? false : x.nonConformities?.some?.((y)=>y?._ref == nonConformity?._id)) 
    //search-box
    const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearch = (e) => {
        setSearchValue(e.target.value);
      };
      const onSearchNc = (e) => {
        setSearchNcValue(e.target.value);
      };
    //==========
  if(loading)return<Loading/>
  return (
    <div style={{width:"100%"}} className="split-view">
        <div className='new-device-container half-left' style = {{...editSizeLeft, overflow: "auto"}}>
            <h2>PRODOTTI ASSEGNATI A NON CONFORMITA'</h2>
            <button onClick={testFunction}>test</button>
            <VisDiv rules={[templateRegisters]}>
                <h4>FILTRA PER FAMIGLIA</h4>
                <SliderRegistriTemplates 
                    registerTemplateFilter={registerTemplateFilter} 
                    setRegisterTemplateFilter={setRegisterTemplateFilter} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    setLoading={setLoading}
                />
            </VisDiv>
            <h4>CERCA</h4>
            <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
            </div>
            <TrueFalseToggle value={empty} onClick={() => setEmpty(!empty)} />
{/*             <h4>VISUALIZZA NON CONFORMITA' FORNITURA</h4>
            <TrueFalseToggle value={supply} onClick={() => setSupply(!supply)} /> */}

            <Divider bottom={"30px"}/>

            {
            !Array.isArray(nonConformities) ? [] : nonConformities
            ?.filter?.(supplyFilter)
            ?.filter?.(nonConformititesFilter)
            ?.sort?.(sortByLabel)
            ?.map?.((nonConformity)=>{
                const nonConfCustomerProducts = filteredCustomerProducts(nonConformity)
                const templateRegistersInNonConf = !Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>nonConformity?.registers?.some?.((y)=>y?._ref == x?._id))
                const nonConfTemplateRegisters = templateRegistersInNonConf?.length > 0 ? templateRegistersInNonConf : templateRegisters
                //console.log("kasndkajsnd", nonConformity)
                const nonConfPresidioModules = nonConfTemplateRegisters?.map?.((item)=>{
                    const modules = 
                        item?.devices
                            ?.map?.((module)=> {
                                const findModule = !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((x)=>x?._id == module?._ref)
                                //console.log("chsjcbsdjcbdsjcbdshjcb", {module, findModule, item})
                                return findModule})
                            ?.filter?.(x=>x)
                    
                    return modules
                })?.flat()
                
               
                return <NonConformityAnalysisPin 

                            key={nonConformity?._id} 
                            customer={customer}
                            nonConformity={nonConformity} 
                            customerProducts={nonConfCustomerProducts}
                            setEditDocument={setEditDocument}   
                            setCustomerProductList={setCustomerProductList} 
                            setDefaultOfferMenu={setDefaultOfferMenu}
                            setNewNonConformity = {setNewNonConformity}
                            setNewCustomerProduct = {setNewCustomerProduct}
                            toggleEdit={toggleEdit}
                            setToggleEdit={setToggleEdit}
                            deviceProperties={deviceProperties}
                            presidioModules={presidioModules}
                            templateRegisters = {nonConfTemplateRegisters}
                        />
            }
        )
        }
        <div style={{minHeight:"200px"}}></div>
        </div>
        <VisDiv rules={[toggleEdit]} style = {{...editSizeRight}} className='new-device-container half-right'>
        <div style={{height: "80vh", display: "flex", flexDirection: "column"}} >
                <div className="titleCloseBtn">
                    <button
                    onClick={() => {
                        setEditDocument(undefined) 
                        setCustomerProductList([]) 
                        setToggleEdit(!toggleEdit)
                        setNewNonConformity(false)
                        setNewCustomerProduct(false)
                    }}
                        
                    >
                    <IoMdCloseCircle size={45}/>
                    </button>
                </div>
                <VisDiv style={{ height:"100%", width:"100%"}} rules={[newCustomerProduct]}>
                    <InsertNewCustomerProduct data={{ priceLists, hideCloseButton: true, customerProducts: customerProducts?.filter?.(x=>!x?.supply), supplyCustomerProducts: customerProducts?.filter?.(x=>x?.supply), nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers }}/>
                </VisDiv>
                <VisDiv style={{height:"100%", width:"100%"}} rules={[newNonConformity]}>
                    <NonConformitiesManagement data={{hideCloseButton: true, nonConformities, customerProducts, templateRegister, deviceProperties, presidioModules, templateRegisters, dataModules, deviceProperties, lists}}/>
                </VisDiv>
                <VisDiv style={{ height:"100%", width:"100%"}} rules={[editDocument]}>
                    <div style={{marginBottom:"15px", marginTop:"15px", display:"flex", width:"100%", justifyContent:"center", flexDirection:"column"}}>
                        <h3>{`PRODOTTI ASSEGNATI ALLA NON CONFORMITA':`}</h3>
                        <h2>{`${editDocument?.nonConformity?.label}`}</h2>
                        <TrueFalseToggle label={"VISUALIZZA PRODOTTI ASSEGNATI"} value={assigned} onClick={() => setAssigned(!assigned)} />
                        <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                            <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearchNc} value={searchNcValue} ref={searchNcRef} />
                        </div>  

                
                        <button type="button" style={{backgroundColor:"green"}} className="btn" onClick={updateCustomerProducts} >{LDB("misc", "save")}</button>
                    </div>
                    <VisDiv rules={[customerProductList]}>
                        {!Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(editNonConfAssigned)?.filter?.(editNonConfSearchFilter)?.sort(sortByLabel)?.map?.((item)=>{
                            //console.log("IN PIN", customerProductList)
                            const isItemInList = customerProductList?.some?.((x)=>x?._id == item?._id)
                            return (
                            <NonConformityPin
                                key = {item?._id}
                                label={item?.label}
                                item={item}
                                array={customerProductList}
                                setArray={setCustomerProductList}
                                initialValue={isItemInList}
                            />
                            )
                        })}
                    </VisDiv>
                </VisDiv>

            </div>
             
        </VisDiv>
       
    </div>
    
  )
}

export default AnalisiNonConformitaEProdotti

/**
 * Takes a customerProduct and optional arrays of presidioModules and deviceProperties, 
 * and returns a new object with the customerProduct and its devices and deviceProperties expanded to include the full objects from the arrays.
 * 
 * @param {Object} data - an object containing a customerProduct and optional arrays of presidioModules and deviceProperties
 * @returns {Object} - a new object with the customerProduct and its devices and deviceProperties expanded to include the full objects from the arrays.
 */
export const expandedCustomerProduct = (data) => {
    const {customerProduct, presidioModules, deviceProperties} = data
    const doc = {
        ...customerProduct,
        deviceProperties: customerProduct?.deviceProperties?.map?.((item)=> !Array.isArray(deviceProperties) ? undefined : deviceProperties?.find?.((y)=>y?._id == item?._ref)),
        devices:customerProduct?.devices?.map?.((item)=> !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((y)=>y?._id == item?._ref)),

    }
    return doc
}

/**
 * Component for displaying a non-conformity and its related customer products.
 * 
 * @param {Object} nonConformity - the non-conformity to display
 * @param {Object} customer - the customer related to the non-conformity
 * @param {(Object) => void} setDefaultOfferMenu - a function to set the default offer menu
 * @param {(Object) => void} setNewNonConformity - a function to set a new non-conformity
 * @param {(Object) => void} setNewCustomerProduct - a function to set a new customer product
 * @param {Array} customerProducts - an array of customer products
 * @param {(Object) => void} setEditDocument - a function to set the edit document
 * @param {(Array) => void} setCustomerProductList - a function to set the customer product list
 * @param {(Boolean) => void} setToggleEdit - a function to set toggle edit
 * @param {Boolean} toggleEdit - a boolean indicating whether the component is in edit mode
 * @param {Array} presidioModules - an array of presidio modules
 * @param {Array} deviceProperties - an array of device properties
 * @param {Array} templateRegisters - an array of template registers
 */
export const NonConformityAnalysisPin = ({nonConformity, customer, setDefaultOfferMenu, setNewNonConformity, setNewCustomerProduct, customerProducts, setEditDocument, setCustomerProductList, setToggleEdit, toggleEdit, presidioModules, deviceProperties, templateRegisters}) => {

        const[deviceFamily, setDeviceFamily] = useState()
        const [registerType, setRegisterType] = useState()
        const deviceFamilies = addValueForDropdown(presidioModules)
        //console.log("nkajcnkanxkjasnckajscn", customerProducts)
        const emptyBackground = (customerProducts?.length < 1 && !nonConformity?.informative) ? {backgroundColor:"#AF7C7B"} : {}
       const filterByDevice = (x)=>{
        if(deviceFamily) return x?.devices?.some?.((y)=>y?._ref == deviceFamily?._id) || x?.devices?.length < 1 || !x?.devices
        return x
       }
    const filterByRegisterType = (x)=>{
       // console.log("lwkdmwlkdmlkdm", {x})
        if(registerType) return x?.registers?.some?.((y)=>y?._ref == registerType?._id)
        return x
       }
      
       
        const editAssignment = () => {
           
            if(!toggleEdit){
                const doc = {nonConformity, customerProducts: customerProducts}
                setEditDocument(doc)
                setCustomerProductList(customerProducts)
                console.log(doc)
            }
            if(toggleEdit){
                setEditDocument(undefined)
                setCustomerProductList([]) 
                console.log(undefined)
            }
            setToggleEdit(!toggleEdit)
            
        }
        const editNonConformity = (NonConf) => {
            //console.log("lkdvhlsdjv", NonConf)
            //setDefaultOfferMenu("NON CONFORMITA")
            setNewNonConformity(NonConf)
            setToggleEdit(!toggleEdit)
        }
        const editCustomerProduct = (customerProduct) => {
            //setDefaultOfferMenu("PRODOTTI INTERNI")
            setNewCustomerProduct(customerProduct)
            setToggleEdit(!toggleEdit)
        }
        const addCustomerProductFromNonConformity = () => {
               const emptyCustomerProductDoc = () => ({
                    _type: "customerProduct",
                    _id: uuidv4(),
                    _key: keyId(),
                    label: nonConformity?.label,
                    customerProductCode:"",
                    customer: referenceDoc(customer?._id),
                    nonConformities: [referenceDoc(nonConformity?._id)],
                    registers: !Array.isArray(nonConformity?.registers) ? [] : nonConformity?.registers,
                    devices: !Array.isArray(nonConformity?.devices) ? [] : nonConformity?.devices,
                    devicesExclude:false,
                    deviceProperties: !Array.isArray(nonConformity?.deviceProperties) ? [] : nonConformity?.deviceProperties,
                    propertiesExclude: false,
                    unit: 1,
                    labourHours: 0.5,
                    specialisedLabour: false,
                    addFormulario: false,
                    isSign: nonConformity?.isSign,
                    supply: false,
                    substitution: false,
                    maintenanceTask: false,
                    allowZero: false, 
                    details: richEditorDoc(capitalizeFirst(nonConformity?.label)),
                    hideNonConformityDescription: false,
                    law: referenceDoc(""),
                    supplierProducts: []
            
                })
            console.log("kjlakdjalksdjlas",{ empty: emptyCustomerProductDoc(), nonConformity})
            setNewCustomerProduct(emptyCustomerProductDoc())
            setToggleEdit(!toggleEdit)
        }
        return(
            <div key={nonConformity?._id} style={{...emptyBackground, minWidth:"70vw", flexDirection:"column", borderRadius:"10px",border:"2px solid grey", padding:"10px", marginBottom:"10px", marginTop:"10px"}}>

                <div style={{marginBottom:"10px", marginTop:"10px", display:"flex", alignItems:"center"}}>
                    <h3>
                        {`NON CONFORMITA': ${nonConformity?.label}`}
                    </h3>
                    <VisDiv className='edit-button-container' style={{justifyContent:"flex-start", marginLeft:"12px"}}>
                        <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={()=>editNonConformity(nonConformity)}>
                            <FiEdit             
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv>
                </div>
                <FilterByRegisterType registerType={registerType} setRegisterType={setRegisterType} nonConformity={nonConformity} templateRegisters={templateRegisters}/>
                <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                    <button 
                        onClick={editAssignment} 
                        className='red-button' 
                        style={{marginLeft:"2px", marginBottom:"5px", backgroundColor:"green"}} 
                        target="_blank" 
                        //href={`https:/gssmega.sanity.studio/desk/nonConformity;${nonConformity?._id}`}
                            >
                            AGGIUNGI/AGGIORNA PRODOTTI
                    </button>
                </div>

                <VisDiv rules={[nonConformity?.isSign]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"amber"}>CARTELLO</TextHighlight>
                </VisDiv>

                <VisDiv rules={[nonConformity?.notification]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"red"}>GRAVE</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.deadline]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"blue"}>SCADENZA</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.substitution]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"yellow"}>SOSTITUZIONE</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.supply]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"green"}>FORNITURA</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.informative]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"blue"}>INFORMATIVO</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.supply]}>
                    <h4>FILTRA PER PRESIDIO:</h4>
                    <FieldDropdown
                        isSearchable="isSearchable"
                        placeHolder={"SELEZIONA PRESIDIO"}
                        options={deviceFamilies}
                        onChange={(value) => { 
                            setDeviceFamily(value)
                        }}
                    />
                </VisDiv>
                <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                    <button 
                        onClick={addCustomerProductFromNonConformity} 
                        className='red-button' 
                        style={{marginLeft:"2px", marginBottom:"5px", backgroundColor:"orange"}} 
                        target="_blank" 
                        //href={`https:/gssmega.sanity.studio/desk/nonConformity;${nonConformity?._id}`}
                            >
                            AGGIUNGI NUOVO PRODOTTO
                    </button>
                    <p style={{marginLeft:"10px"}}>IMPORTANTE: Fare almeno una modifica per salvare il prodotto. I dati vengono presi dalla non conformità.</p>
                </div>
                <VisDiv rules={[customerProducts?.length>0]}>
                    {"PRODOTTI: "}
                    {!Array.isArray(customerProducts) ? [] : customerProducts?.filter?.(filterByRegisterType)?.filter?.(filterByDevice)?.sort(sortByLabel)?.map?.((customerProduct)=>{
                        const expandedDoc = expandedCustomerProduct({customerProduct, deviceProperties, presidioModules})
                        //console.log("EXPANDED DOC", expandedDoc)
                        return(
                        <Fragment key={customerProduct?._id}>
                            <div style={{display:"flex", alignItems:"left", textAlign:"left", padding:"15px"}}>
                                <div style={{display:"flex", textAlign:"left", flexDirection:"column", justifyContent:"left", alignItems:"left"}}>
                                    <div style={{display:"flex", textAlign:"left", alignItems:"center"}}>
                                        <h4>{customerProduct?.label}</h4>
                                        <VisDiv className='edit-button-container' style={{justifyContent:"flex-start", marginLeft:"6px"}}>
                                            <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={()=>editCustomerProduct(customerProduct)}>
                                                <FiEdit             
                                                size={15}
                                                color={"white"}/>
                                            </button>
                                        </VisDiv>
                                    </div>
                                    <div onClick={()=>console.log("ajdliwqjd", {expandedDoc, presidioModules, customerProduct, deviceProperties})} style={{display:"flex", textAlign:"left"}}>
                                        {"PRESIDI: "}
                                        <p>{expandedDoc?.devices?.map?.(x=>` ${x?.label}`)?.toString()}</p>
                                    </div>
                                    <div style={{display:"flex", textAlign:"left"}}>
                                        <p>{`PROPRIETA': `}</p>
                                        <p>{expandedDoc?.deviceProperties?.map?.(x=>` ${x?.label}`)?.toString()}</p>
                                    </div>
                                    <VisDiv rules={[customerProduct?.substitution]} style={{marginTop:"15px"}}>
                                        <TextHighlight highlight={"yellow"}>SOSTITUZIONE</TextHighlight>
                                    </VisDiv>
                                    <VisDiv rules={[customerProduct?.supply]} style={{marginTop:"15px"}}>
                                        <TextHighlight highlight={"green"}>FORNITURA</TextHighlight>
                                    </VisDiv>
                                </div>
                            </div>
                            <Divider bottom={"12px"}/>
                        </Fragment>
                        )
                    })}                     
                </VisDiv>

            </div>
        )
    }


/**
 * FilterByRegisterType component
 * 
 * This component renders a list of register templates that correspond to the non-conformity 
 * of a customer product. The list is sorted by the order of the register templates, and 
 * each item shows the icon of the register template. If the user clicks on one of the items, 
 * the FilterByRegisterType component will set the registerType state to the corresponding clicked item.
 * 
 * @param {object} props - an object containing the data needed by the component, {registerType, setRegisterType, nonConformity, templateRegisters}
 * @returns - a JSX element
 */
    export const FilterByRegisterType = ({registerType, setRegisterType, nonConformity, templateRegisters}) => {
    function compare( a, b ) {
        if ( a?.order < b?.order ){
          return -1;
        }
        if ( a?.order > b?.order ){
          return 1;
        }
        return 0;
      }
      const setFilter = (item, site) => {
          console.log("ksjandkwednkj clicked register", {item})
          if(registerType?._id == item?._id) setRegisterType(undefined)
          else{
            setRegisterType(item)
            }
     
      }
        //if(templateRegisters?.length >1) console.log("NON CONF skdnkllds:", {nonConformity, templateRegisters})
        return (
            <VisDiv   style={{display:"flex", flexWrap:"wrap", justifyContent:"left", alignItems:"center", gap:"10px", marginBottom:"10px"}}>
            {nonConformity?.registers?.length > 0 && (!Array.isArray(templateRegisters) ? [] : templateRegisters.sort(compare).map?.((item)=>(
                <VisDiv key={item._id} className='horizontal-swipe-box' style={{backgroundColor:"",}}> 
                    <RegisterIcon currentTemplate={registerType} noPlus={true} template={item} templates={templateRegisters} onClick={()=>setFilter(item)}/> 
                </VisDiv>
          )))}
            </VisDiv>
        )
        
    }
